module.exports = __webpack_public_path__ + "fonts/737e8e7.TTF";